(() => {
  const setupSlider = (root, slideSelector, prevSelector, nextSelector, dotSelector) => {
    const slides = [...root.querySelectorAll(slideSelector)];
    if (slides.length < 2) return;
    const dots = [...root.querySelectorAll(dotSelector)];
    let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    const play = () => {
      if (root.dataset.autoplay !== 'true') return;
      clearInterval(timer);
      timer = setInterval(() => show(index + 1), Number(root.dataset.speed || 6000));
    };
    root.querySelector(prevSelector)?.addEventListener('click', () => { show(index - 1); play(); });
    root.querySelector(nextSelector)?.addEventListener('click', () => { show(index + 1); play(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.slideDot)); play(); }));
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', play);
    play();
  };

  document.querySelectorAll('[data-slideshow]').forEach((root) => setupSlider(root, '[data-slide]', '[data-slide-prev]', '[data-slide-next]', '[data-slide-dot]'));
  document.querySelectorAll('announcement-slider').forEach((root) => setupSlider(root, '[data-announcement-slide]', '[data-announcement-prev]', '[data-announcement-next]', '[data-announcement-dot]'));

  document.querySelectorAll('[data-product-carousel]').forEach((root) => {
    const track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    const amount = () => Math.max(track.clientWidth * .82, 320);
    root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
    root.querySelector('[data-carousel-next]')?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
  });
})();
